import { render } from "./HomeBanner.vue?vue&type=template&id=349e0dcf&scoped=true&ts=true"
import script from "./HomeBanner.vue?vue&type=script&lang=ts"
export * from "./HomeBanner.vue?vue&type=script&lang=ts"

import "./HomeBanner.vue?vue&type=style&index=0&id=349e0dcf&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349e0dcf"]])

export default __exports__